import mccLogo from '@/assets/mcc_logo.png'

export default function Loader() {
  return (
    <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
      <img
        src={mccLogo}
        alt="Loading"
        className="w-64 animate-pulse duration-300"
      />
    </div>
  )
}
